import { AbstractControl, ValidatorFn } from '@angular/forms';

export function trueValueValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value !== true) {
            return { trueValueRequired: true };
        }
        return null;
    };
}